export const VoucherIndexSceneTranslation = {
  fi: {
    VoucherIndexScene: {
      title: 'Kupongit',
      create: 'Luo uusi',
    },
  },
};
